"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Cookie {
    /**
     * Configures the cookie.
     *
     * @param {string} name
     * @param {string} value
     * @param {number} expiresInDays
     * @param {string} domain
     * @return {string}
     */
    setCookie(name, value, expiresInDays, domain) {
        const cookie = `${name}=${value}`;
        const expiresStr = `expires=${this.formatExpirationInDays(expiresInDays)}`;
        const domainStr = `domain=${domain}`;
        const cookieString = `${cookie}; ${expiresStr}; ${domainStr}; path=/;`;
        document.cookie = cookieString;
        return cookieString;
    }
    /**
     * Gets cookie value.
     *
     * @param cookieName
     * @returns {*}
     */
    getCookie(cookieName) {
        const name = cookieName + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieParts = decodedCookie.split(';');
        for (let i = 0; i < cookieParts.length; i++) {
            let cookieData = cookieParts[i];
            while (cookieData.charAt(0) === ' ') {
                cookieData = cookieData.substring(1);
            }
            if (cookieData.indexOf(name) === 0) {
                // Return only cookie value.
                return cookieData.substring(name.length, cookieData.length).split(',')[0];
            }
        }
        return "";
    }
    /**
     *  Reset the cookie to epoch time.
     *
     * @param cookieName
     */
    removeCookie(cookieName, cookieDomain) {
        this.setCookie(cookieName, this.getCookie(cookieName), Math.floor(new Date().getDate() / 86400000), cookieDomain);
    }
    /**
     * Formats the expiration date of the cookie.
     *
     * @param {number} days
     * @return {number}
     */
    formatExpirationInDays(days) {
        const now = new Date();
        now.setDate(now.getDate() + days);
        return now;
    }
}
exports.default = Cookie;
